import { ScopeTreeItem } from '@/services/Scopes/Interfaces'
import { Treeview } from '@/views/interfaces/vuetify/treeview.interface'

export class ScopeTreeLeaf implements ScopeTreeItem {
  constructor(
    public id: string,
    public name: string,
    public disabled: boolean = false,
  ) {
  }

  public toTreeView(): Treeview {
    return {
      id: this.id,
      name: this.name,
    }
  }
}
